

























import {Component, Prop, Vue} from 'vue-property-decorator'
import WhatsAppConversation from "../views/WhatsAppConversation.vue";
import {LogElement} from "@/model/chatbot-log";
//@ts-ignore
import JsonViewer from 'vue-json-viewer';

@Component({
  components: {WhatsAppConversation, JsonViewer}
})
export default class ChatbotServiceLog extends Vue {

  @Prop()
  log!: LogElement

  expand = false

  isEmpty(obj: any) {
    for(const prop in obj) {
      if(obj.hasOwnProperty(prop))
        return false;
    }

    return true;
  }
}
